// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Box } from '@mui/material';

import IconGo from './icon_go.svg';
import IconGoDis from './icon_go_dis.png';

const DateTitle: React.FC<{ disable: boolean; start: string; end: string }> = ({
  disable,
  end,
  start
}) => {
  return (
    <Box
      sx={{
        width: '184px',
        height: '36px',
        background: disable ? '#EAEFEF' : '#FFFFFF',
        color: disable ? '#999' : '#000',
        boxShadow: '0px 3px 20px rgba(27,145,150,0.5)',
        borderRadius: '21px',
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        fontSize: '18px'
      }}
    >
      {start}
      <Box
        sx={{
          width: '16px',
          height: '16px',
          background: disable ? 'transparent' : 'rgba(27,145,150,0.71)',
          border: disable ? '1px solid #999' : 'none',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <img src={disable ? IconGoDis : IconGo} />
      </Box>
      {end}
    </Box>
  );
};

export default DateTitle;
